import { render } from "./about.vue?vue&type=template&id=da64c9f2"
const script = {}

import "./about.vue?vue&type=style&index=0&id=da64c9f2&lang=css"

import exportComponent from "X:\\Proyecto\\riego-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__